import { DateTransform } from '@ember-data/serializer/transform';

export default class MyDateTransform extends DateTransform {
  deserialize(serialized) {
    // console.log('serialized', typeof serialized, serialized);
    let type = typeof serialized;

    if (type === 'string') {
      if (serialized.length === 19) {
        serialized += '.000Z';
      } else {
        serialized += 'Z';
      }
      let offset = serialized.indexOf('+');

      if (offset !== -1 && serialized.length - 5 === offset) {
        offset += 3;
        return new Date(
          serialized.slice(0, offset) + ':' + serialized.slice(offset)
        );
      }
      return new Date(serialized);
    } else if (type === 'number') {
      return new Date(serialized);
    } else if (serialized === null || serialized === undefined) {
      // if the value is null return null
      // if the value is not present in the data return undefined
      return serialized;
    } else {
      return null;
    }
  }
  serialize(date) {
    if (date instanceof Date && !isNaN(date)) {
      // FF: habe ich zwischenzeitlich mal genutzt, damit in der DB die richtigen stehen
      // date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toISOString().slice(0, -1);
    } else {
      return null;
    }
  }
}
